import { call, put } from "redux-saga/effects";

import { api, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateScheduledOrdersFOBActions } from "store/ducks/ordersFob";

export function* paginateScheduledOrdersFOBRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder({
      ...query,
    });

    const { data: responseBody } = yield call(
      api.get,
      `/orders-fob-scheduled?${queryString}`
    );

    const { data, pagination } = responseBody;
    yield put(PaginateScheduledOrdersFOBActions.success(data, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateScheduledOrdersFOBActions.failure(errorMessage));
  }
}
